import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import {
  RequestDate,
  RequestDatesListItem,
  RequestDateStatus,
  RequestDateToolbar,
  RequestDateWrapper
} from './request-date-item.styles';

export const RequestDateItemSkeleton: FC = (props) => {
  return (
    <RequestDatesListItem>
      <RequestDateWrapper>
        <RequestDate>
          <Skeleton variant="text" width={130} height={15} />
        </RequestDate>
        <RequestDateStatus>
          <Skeleton variant="circular" width={10} height={10} sx={{ marginRight: '5px' }} />
          <Skeleton variant="text" width={70} height={15} />
        </RequestDateStatus>
      </RequestDateWrapper>
      <Box sx={{ marginTop: '5px' }}>
        <Skeleton variant="text" width={90} height={15} />
      </Box>
      <RequestDateToolbar>
        <Skeleton variant="rounded" width={60} height={18} sx={{ marginRight: '10px' }} />
        <Skeleton variant="rounded" width={75} height={18} />
      </RequestDateToolbar>
    </RequestDatesListItem>
  );
};
